<template>
  <div v-if="config" class="apply-bottom">
    <div class="apply">
      <div class="price">
        <div class="actual">{{ config.price }}</div>
        <div v-if="config.origin_price && showTagLeft" class="del-price">
          官网价 {{ config.origin_price }}
        </div>
      </div>
      <div class="desc-wrap">
        <div v-if="config.tag" class="label" :style="{ background: bgColor }">
          {{ config.tag }}
        </div>
        <div v-if="config.tips" class="desc" v-html="config.tips"></div>
        <div v-if="config.origin_price && !showTagLeft" class="del-price">
          官网价 {{ config.origin_price }}
        </div>
      </div>
      <button
        :class="{ disable: !isAgree, large: !config.tag && !config.tips }"
        :style="{ background: bgColor }"
        :disabled="!isAgree"
        class="btn-apply"
        @click="handleUserAction"
      >
        {{ config.button || '马上报名' }}
      </button>
    </div>
    <div v-if="hasTimer" :class="{ timer: true, price: priceCountDown }">
      <span v-if="deadlineTexts[0]" class="label">{{ deadlineTexts[0] }}</span>
      <span v-if="Number(day) !== 0 || priceCountDown" class="number">{{
        day
      }}</span>
      <span v-if="Number(day) !== 0 || priceCountDown">天</span>
      <span class="number">{{ hour }}</span>
      <span>时</span>
      <span class="number">{{ minute }}</span>
      <span>分</span>
      <span class="number">{{ second }}</span>
      <span>秒</span>
      <span v-if="deadlineTexts[1]" class="label">{{ deadlineTexts[1] }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { countTime } from '@lib/timer';
import { countDown } from '../../utils/countDown';

@Component({})
export default class Apply extends Vue {
  @Prop({ type: Boolean }) isAgree!: boolean;
  @Prop() config!: any;
  @Prop({ default: false }) hasTimer!: boolean;
  @Prop({ default: 0 }) deadline!: number;
  @Prop({ default: '' }) deadlineText!: string;
  @Prop({}) bgColor!: string;
  // 是否为涨价倒计时
  @Prop({ default: 0 }) priceCountDown!: number;

  get showTagLeft() {
    const { tag, tips } = this.config;
    return !tag || (tag && tips);
  }

  get deadlineTexts() {
    if (this.priceCountDown) {
      return ['距涨价还有', ''];
    } else {
      return this.deadlineText.split('【n】');
    }
  }

  timer: any = null;
  day = '00';
  hour = '00';
  minute = '00';
  second = '00';
  msecond = '00';

  handleUserAction() {
    this.$emit('apply');
  }
  mounted() {
    if (this.hasTimer) {
      this.start();
    }
  }
  beforeDestroy() {
    this.stop();
  }
  start() {
    if (this.priceCountDown) {
      this.timer = this.getPriceTimer();
    } else {
      this.timer = this.getCouponTimer();
    }
  }
  // 优惠券倒计时
  getCouponTimer() {
    return countTime(
      {
        endTime: this.deadline * 1000,
        interval: 1000,
      },
      ({ day, minute, second, hour }) => {
        this.checkTimerDone(day, minute, second, hour);
      }
    );
  }
  // 涨价倒计时
  getPriceTimer() {
    return countDown(
      {
        count: this.priceCountDown * 1000,
        interval: 1000,
      },
      ({ day, minute, second, hour }) => {
        this.checkTimerDone(day, minute, second, hour);
      }
    );
  }
  // 校验倒计时是否结束
  checkTimerDone(
    day: number | string,
    minute: number | string,
    second: number | string,
    hour: number | string
  ) {
    this.day = `${day}`;
    this.hour = `${hour}`;
    this.minute = `${minute}`;
    this.second = `${second}`;
    if (
      !Number(this.day) &&
      !Number(this.hour) &&
      !Number(this.minute) &&
      !Number(this.second) &&
      !Number(this.msecond)
    ) {
      this.stop();
      this.$emit('stopCount');
    }
  }
  stop() {
    this.timer && this.timer.stop();
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/helps.scss';
@import '../../styles/apply.scss';

.timer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 60px;
  color: #fff;
  font-size: 20px;
  line-height: 60px;
  text-align: center;
  background-color: #fa6a6a;

  .label {
    margin: 0 4px;
  }

  .number {
    display: block;
    width: 40px;
    margin: 0 8px 0 12px;
    font-weight: 500;
    font-size: 32px;
  }

  &.price {
    height: 50px;
    line-height: 50px;
  }
}
</style>